import { render, staticRenderFns } from "./ProductClusterList.vue?vue&type=template&id=62a0c3b5&scoped=true"
import script from "./ProductClusterList.vue?vue&type=script&lang=js"
export * from "./ProductClusterList.vue?vue&type=script&lang=js"
import style0 from "./ProductClusterList.vue?vue&type=style&index=0&id=62a0c3b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a0c3b5",
  null
  
)

export default component.exports